import { useEffect, useState } from "react";
import { AdviseLabels } from "../enums/MessageEnum";

export default function BurgerNavbar(props){

    const [dropDownOpen, setDropDownOpen] = useState(false)

    const handleClickOutside = (event) => {
        if (props.navbarRef.current && !props.navbarRef.current.contains(event.target)) {
          props.setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
    // eslint-disable-next-line
    }, []);

    const selectedClass = "block py-2 px-3 text-white bg-blue-700 rounded dark:bg-blue-600"
    const normalClass   = "block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white"

    return(
        <>
            <button data-collapse-toggle="navbar-hamburger" type="button" 
            className="inline-flex items-center justify-center p-2 w-10 h-10 
            text-sm text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none 
            focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 
            dark:focus:ring-gray-600" aria-controls="navbar-hamburger" aria-expanded="false"
            onClick={() => {props.setIsOpen(!props.isOpen)}}>
                <span className="sr-only">Open main menu</span>
                <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" 
                    strokeWidth="2" d="M1 1h15M1 7h15M1 13h15"/>
                </svg>
            </button>
            {
                props.isOpen ? 
                    <div className="w-full" id="navbar-hamburger">
                        <ul className="flex flex-col font-medium mt-4 rounded-lg bg-gray-50 dark:bg-gray-800 dark:border-gray-700">
                            { 
                                props.options.map(function(optionIndex, optionValue) {
                                    if (optionValue !== props.options.length - 1)
                                        return(
                                            <li key={optionIndex + optionValue}>
                                                <a href={"#" + props.routes[optionValue]} 
                                                    className={props.selected === optionValue ? selectedClass : normalClass}
                                                    onClick={(e) => {
                                                        props.manageClick(e, optionValue)
                                                    }}>
                                                    {optionIndex}
                                                </a>
                                            </li>
                                        );
                                    return(
                                        <li key={optionIndex + optionValue}>
                                            <button id="dropdownNavbarLink"
                                                className="flex items-center justify-between w-full py-2 px-3 
                                                text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent 
                                                md:border-0 md:hover:text-blue-700 md:p-0 md:w-auto dark:text-white 
                                                md:dark:hover:text-blue-500 dark:focus:text-white dark:border-gray-700 
                                                dark:hover:bg-gray-700 md:dark:hover:bg-transparent"
                                                onClick={() => {setDropDownOpen(!dropDownOpen)}}>
                                                    {optionIndex} 
                                                    <svg className="w-2.5 h-2.5 ms-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" 
                                                    fill="none" viewBox="0 0 10 6">
                                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" 
                                                        strokeWidth="2" d="m1 1 4 4 4-4"/>
                                                    </svg>
                                            </button> 
                                            {dropDownOpen ?
                                                <div className="dropdown-help-burger">
                                                    <ul className="flex flex-col font-medium 
                                                    rounded-lg bg-gray-50 dark:bg-gray-800 
                                                    dark:border-gray-700">
                                                        <li>
                                                            <a
                                                                href="/assets/pdf/ADV_ProgramaIntegridad_v1.0.1.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className={normalClass}>
                                                                {AdviseLabels.HELP_PROGRAM}
                                                            </a>
                                                        </li>
                                                    </ul>
                                                    <ul className="flex flex-col font-medium
                                                    rounded-lg bg-gray-50 dark:bg-gray-800
                                                    dark:border-gray-700">
                                                        <li>
                                                            <a
                                                                href="/assets/pdf/RES_EXENTA_40_Horas.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className={normalClass}>
                                                                {AdviseLabels.SEAL_40_HRS}
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                : <></>}
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div> :
                    <></>
            }
        </>
    );
}